/**
 * SMS Configuration API Service
 * 
 * GraphQL operations for managing SMS configuration
 */

import { gql } from "@apollo/client";

// Types
export interface SMSConfiguration {
  originationNumber: string;
  senderId?: string;
  configurationSet?: string;
  enabled: boolean;
}

export interface SMSConfigurationInput {
  originationNumber: string;
  senderId?: string;
  configurationSet?: string;
  enabled: boolean;
}

export interface UpdateSMSConfigurationInput {
  tenantId: string;
  smsConfiguration: SMSConfigurationInput;
}

// GraphQL Queries
export const GET_SMS_CONFIGURATION = gql`
  query GetSMSConfiguration($tenantId: ID) {
    getSMSConfiguration(tenantId: $tenantId) {
      originationNumber
      senderId
      configurationSet
      enabled
    }
  }
`;

// GraphQL Mutations
export const UPDATE_SMS_CONFIGURATION = gql`
  mutation UpdateSMSConfiguration($input: UpdateSMSConfigurationInput!) {
    updateSMSConfiguration(input: $input) {
      originationNumber
      senderId
      configurationSet
      enabled
    }
  }
`;

// Query and Mutation Response Types
export interface GetSMSConfigurationResponse {
  getSMSConfiguration: SMSConfiguration | null;
}

export interface UpdateSMSConfigurationResponse {
  updateSMSConfiguration: SMSConfiguration;
}

// Variables Types
export interface GetSMSConfigurationVariables {
  tenantId?: string;
}

export interface UpdateSMSConfigurationVariables {
  input: UpdateSMSConfigurationInput;
}
